/**
 * Schema of RelatorioGeracao
 * @author gabrielgil
 */
import {Schema} from 'simpli-web-sdk'
import {date, datetime} from 'simpli-web-sdk'
import RelatorioGeracao from '@/model/resource/RelatorioGeracao'
import RenderExclamation from '@/components/render/RenderExclamation.vue'

export default (model: RelatorioGeracao): Schema => ({
  idRelatorioGeracaoPk: {
    content: model.idRelatorioGeracaoPk,
    editable: false,
  },

  dataCriacao: {
    content: datetime(model.dataCriacao),
  },

  dataInicio: {
    content: date(model.dataInicio) || '-',
  },

  dataFim: {
    content: (date(model.dataFim) || date(model.dataGeracaoRelatorio)) || '-',
  },

  dataGeracaoRelatorio: {
    content: datetime(model.dataGeracaoRelatorio),
  },

  arquivoSolicitado: {
    content: model.tipoRelatorioDescricao || '-',
  },

  urlDownload: {
    content: {
      props: {
        value: model.devoExecutarMadrugada && !model.urlDownload,
        href: model.urlDownload,
        label: model.devoExecutarMadrugada && !model.urlDownload ? 'Relatório Agendado' :
            (model.urlDownload ? 'Baixar Relatório' : 'Aguardando'),
        target: '_blank',
        anchorClass: model.devoExecutarMadrugada && !model.urlDownload ? 'tc-danger' :
            (model.urlDownload ? 'tc-seagreen' : 'tc-primary'),
        anchorStyle: model.urlDownload ?
            'pointer-events: auto; cursor: pointer;' : 'pointer-events: none; cursor: default',
      },
      component: RenderExclamation,
    },
  },
})
